import { render, staticRenderFns } from "./MenuAdd.vue?vue&type=template&id=230722b8&scoped=true"
import script from "./MenuAdd.vue?vue&type=script&lang=js"
export * from "./MenuAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230722b8",
  null
  
)

export default component.exports